import { render } from "./OutletLabelPrint.vue?vue&type=template&id=51f51a70"
import script from "./OutletLabelPrint.vue?vue&type=script&lang=js"
export * from "./OutletLabelPrint.vue?vue&type=script&lang=js"

import "./OutletLabelPrint.vue?vue&type=style&index=0&id=51f51a70&lang=css"

import exportComponent from "/home/pewholesaleinnovelapp/wholesale.fresherproduce.ca/releases/81914199/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__